import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Line } from 'react-konva';
import { makeStyles } from '@material-ui/styles';
import styles from './SketchLine.styles';
const useStyles = makeStyles(styles);

const SketchLine = ({ id, points }) => {
  const classes = useStyles();
  const line = useRef(null);
  return <Line ref={line} key={`Line${id}`} points={points} stroke="black" strokeWidth={3} closed />;
};
SketchLine.defaultProps = {};
SketchLine.propTypes = {
  prop: PropTypes.string,
};

export default SketchLine;
